/**
 * Skip navigation link for keyboard accessibility.
 * Hidden by default, becomes visible when focused via Tab key.
 * Links to the main content area, allowing keyboard users to bypass navigation.
 */
export function SkipLink() {
    return (
        <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-2 focus:text-max-900 focus:rounded focus:shadow-lg focus:outline-none focus:ring-2 focus-visible:ring-max-700"
        >
            Skip to main content
        </a>
    );
}

export default SkipLink;
